module.exports = __webpack_public_path__ + "static/img/download_btn.348b20d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/download_btn.png
// module id = 806
// module chunks = 13